import React, { useId } from 'react';

import { SvgIcon } from '../../SvgIcon';
import { HelperText } from '../HelperText';
import { Label } from '../Label';
import { mergeRefs } from '../utils';

import {
  StyledSelect,
  StyledSelectContainer,
  StyledSelectPaper,
} from './styles';
import { TSelectProps } from './types';

const ChevronDown = (props: Record<string, string>) => (
  <SvgIcon name="chevron-down" {...props} />
);

export const Select = React.forwardRef<HTMLInputElement, TSelectProps>(
  (
    {
      id,
      label,
      children,
      error,
      helperText,
      errorsMessage,
      sx,
      className,
      fullWidth = true,
      size = 'medium',
      inputRef,
      ...otherProps
    },
    ref
  ) => {
    const generateId = useId();
    const inputId = id || `select-field-${generateId}`;
    const helperTextId = `helper-text-${generateId}`;

    const mergedInputRef = mergeRefs(inputRef, ref);

    return (
      <StyledSelectContainer
        sx={sx}
        className={className}
        fullWidth={fullWidth}
      >
        {label ? (
          <Label id={inputId} error={error || !!errorsMessage}>
            {label}
          </Label>
        ) : null}
        <StyledSelect
          id={inputId}
          variant="outlined"
          fullWidth={fullWidth}
          size={size}
          error={error || !!errorsMessage}
          aria-describedby={helperText ? helperTextId : undefined}
          IconComponent={ChevronDown}
          inputRef={mergedInputRef}
          MenuProps={{
            PaperProps: {
              component: StyledSelectPaper,
            },
          }}
          {...otherProps}
        >
          {children}
        </StyledSelect>
        {helperText ? (
          <HelperText id={helperTextId}>{helperText}</HelperText>
        ) : null}
      </StyledSelectContainer>
    );
  }
);

Select.displayName = 'Select';
